import {
  deleteV1DealerIdBorrowerBorIdExpenseExpId,
  getV1DealerIdBorrowerBorIdExpenses,
  postV1DealerIdBorrowerBorIdExpense,
  putV1DealerIdBorrowerBorIdExpenseExpIdUpdateExpense,
  type DtoCreateExpenseReq,
  type DtoUpdateExpenseReq,
} from "@porchpass/api-client";
import {
  assertApiSuccess,
  assertApiSuccessNoContent,
} from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { lazyDealerId, requireBorrowerId, type DomainIds } from "./types";

export function createExpenseDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getExpenses: async (borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorIdExpenses(
        getDealerId(),
        borId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },

    createExpense: async (body: DtoCreateExpenseReq, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await postV1DealerIdBorrowerBorIdExpense(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess(response);
    },

    updateExpense: async (
      expenseId: string,
      body: DtoUpdateExpenseReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response =
        await putV1DealerIdBorrowerBorIdExpenseExpIdUpdateExpense(
          getDealerId(),
          borId,
          expenseId,
          body,
        );
      return assertApiSuccess(response);
    },

    deleteExpense: async (expenseId: string, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await deleteV1DealerIdBorrowerBorIdExpenseExpId(
        getDealerId(),
        borId,
        expenseId,
        EMPTY_REQUEST_BODY,
      );
      assertApiSuccessNoContent(response);
    },
  };
}
